module.exports = __webpack_public_path__ + "static/media/icon-ecommerce.8c850828.svg";